<template lang="pug">
.page.list-posts
  .container.page-header
    create-button

  .container.--wide
    .list-posts__header
      h1 
        span Welcome to my 
        span.vue-board--vue vue
        span Board

      .post-list-display-buttons
        a(
          :class="{ '--active': displayType === 'grid' }"
          @click="setDisplayType('grid')"
        ) grid
        span  | 
        a(
          :class="{ '--active': displayType === 'li' }"
          @click="setDisplayType('li')"
        ) list

    post-list(
      :posts="posts"
      :display="displayType"
    )
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import CreateButton from '@/components/create-button'
import PostList from '@/components/post/post-list'

export default {
  name: 'list-posts',
  components: {
    CreateButton,
    PostList,
  },
  computed: {
    ...mapState(['config']),
    ...mapGetters(['posts']),
    displayType() {
      return this.config.listPage.displayType
    },
  },
  methods: {
    ...mapMutations(['setConfig']),
    setDisplayType(value) {
      this.setConfig({ key: 'listPage.displayType', value })
    },
  }
}
</script>

<style lang="sass">
.vue-board--vue
  background-color: hsla(var(--accent-color-h),var(--accent-color-s),var(--accent-color-l), .65)

.list-posts__header
  display: flex
  justify-content: space-between
  align-items: center

.post-list-display-buttons a
  &.--active
    font-weight: 600
</style>
